<script setup lang="ts">
// Live text keeps the name accessible; the geometric Setflows SVG stays
// sharp at every size. Worshipr retains its original Merriweather mark, in
// the colour of the text around it.
defineProps<{ name: string }>();
</script>

<template>
  <template v-if="name === 'Worshipr'">
    <span class="sr-only">{{ name }}</span>
    <span aria-hidden="true"
      ><span class="brand-w"></span>orshipr</span
    >
  </template>
  <span v-else-if="name === 'Setflows'" class="setflows-wordmark">
    <img src="@/assets/setflows-mark.svg" alt="" class="setflows-mark" />
    <span>{{ name }}</span>
  </span>
  <template v-else>{{ name }}</template>
</template>

<style scoped>
/* The glyph is 1056.4 font units wide and 743 tall (1000 per em). Its ink
   overhangs its advance box by 0.019em on the left and 0.010em on the right,
   and the font kerns "Wo" a further 0.046em tighter. It is a mask over the
   text colour, so it is black where the rest of the name is and follows it
   into dark mode. */
.brand-w {
  display: inline-block;
  width: 1.0564em;
  height: 0.743em;
  margin: 0 -0.056em 0 -0.019em;
  vertical-align: baseline;
  background-color: currentColor;
  mask: url("@/assets/logo.svg") center / contain no-repeat;
}

.setflows-wordmark {
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  vertical-align: middle;
  font-family: "Arial Black", "Helvetica Neue", Arial, sans-serif;
  font-weight: 900;
  letter-spacing: -0.055em;
  line-height: 1.05;
}

.setflows-mark {
  height: 0.84em;
  width: auto;
  flex: none;
}
</style>
